/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'company-hub-common.ai.error.common-error.general-error':
    '現在 Atlassian Intelligence は回答を提供できません。詳細は<a>サポート ドキュメント</a>でご確認ください。',
  'company-hub-common.ai.error.common-error.not-enough-content':
    '要約に必要な量のコンテンツがありません。コンテンツが追加されたらもう一度お試しください。',
  'company-hub-common.ai.error.common-error.rate-limit':
    'Atlassian Intelligence で過度の使用が検出されました。あとでもう一度お試しください。詳細は<a>サポート ドキュメント</a>でご確認ください。',
  'company-hub-common.ai.error.page-error.aup-violation':
    'あなたのコンテンツはアトラシアンの利用規定に準拠していない可能性があります。コンテンツをレビューし、必要に応じて<a>利用規定</a>を参照してください。',
  'company-hub-common.ai.error.page-error.too-much-content':
    '要約する内容が多すぎるため、現在 Atlassian Intelligence は要約を生成できません。',
  'company-hub-common.attachment-size-limit-error.description': '添付ファイルのサイズは {size} 以下にしてください。',
  'company-hub-common.attachment-size-limit-error.learn-more': '詳細',
  'company-hub-common.attachment-size-limit-error.title': '{fileName} は大きすぎてアップロードできません',
  'company-hub-common.attachment-zero-byte-error.title': '{fileName} は空 (0 バイト) です',
  'company-hub-common.attachment-zero-byte.description': '添付ファイルのサイズは 1 バイト以上にしてください',
  'company-hub-common.config-panel.new-lozenge-label': 'NEW',
  'company-hub-common.config-panel.panel-close-button.close-label': '構成パネルを閉じる',
  'company-hub-common.emoji-title.icon.embed': '埋め込み',
  'company-hub.common.media-components.media-picker.ui.content.inspiration.text': '参考情報',
  'company-hub.common.media-components.media-picker.ui.content.placeholder.text': 'URL からリンクを追加',
  'company-hub.common.media-components.unsplash.unsplash-browser.button.text': 'Unsplash を参照',
  'company-hub.common.media-components.unsplash.unsplash-browser.error.text':
    'このリンクへのアクセスで問題が発生しました。もう一度お試しください。',
  'company-hub.company-hub-common.ui.empty-state.label-placeholder': 'ラベル',
  'custom-sites-extensions.config-panel.add-card-cta': 'カードを追加',
  'custom-sites-extensions.config-panel.content.label-button.popup.hide-label-button.text': 'ラベルを非表示',
  'custom-sites-extensions.config-panel.content.label-button.popup.title': 'ラベル',
  'custom-sites-extensions.config-panel.content.label-button.title': 'ラベル',
  'custom-sites-extensions.config-panel.feedback-collector.preamble.first-line':
    '皆様のご意見は、アトラシアンがご要望にお応えするために欠かせません。改善が必要な点はありますか?',
  'custom-sites-extensions.config-panel.feedback-collector.summary-placeholder':
    'どのような点が良かったですか? 改善が必要な点はありますか?',
  'custom-sites-extensions.config-panel.feedback-section.preamble': 'フィードバックにご協力ください。',
  'custom-sites-extensions.config-panel.feedback-section.share-feedback-button.text-extension':
    '{type, select, Cards {カードに関するフィードバックを送信} Carousel {カルーセルに関するフィードバックを送信} Linksmenu {リンク メニューに関するフィードバックを送信} Spotlight {スポットライトに関するフィードバックを送信} Section {セクションに関するフィードバックをぜひお寄せください} Customsearch {カスタム検索に関するフィードバックを送信} Companyhub {会社ハブに関するフィードバックをお寄せください} other {ご意見をお聞かせください}}',
  'custom-sites-extensions.config-panel.render-variant.dropdown.label': 'カード タイプ',
  'custom-sites-extensions.config-panel.render-variant.dropdown.option.label.dynamic': '動的',
  'custom-sites-extensions.config-panel.render-variant.dropdown.option.label.manual': '手動',
  'custom-sites-extensions.link-cards-content.card-components.error-states.loading-cards-error-preamble':
    'カードの読み込み中に問題が発生しました。',
  'custom-sites-extensions.link-cards-content.card-components.error-states.loading-cards-error-support':
    '再読み込みしてもう一度お試しください。',
  'custom-sites-extensions.link-cards.card.collapse.label': 'カードを折りたたむ',
  'custom-sites-extensions.link-cards.card.expand.label': 'カードを展開',
  'custom-sites-extensions.link-cards.card.image.section.label': '画像',
  'custom-sites-extensions.link-cards.card.remove.card.label': 'カードを削除',
  'custom-sites-extensions.link-cards.card.title': 'カード {order}',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.arrow.down': '下へ',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.arrow.up': '上へ',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.move.down.label':
    '下に移動',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.move.up.label':
    '上に移動',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.reorder': '並べ替え',
  'custom-sites-extensions.link-cards.description.ai-disclaimer': 'コンテンツの質にはばらつきがある場合があります',
  'custom-sites-extensions.link-cards.description.button.suggest-description.label': '説明の候補を生成',
  'custom-sites-extensions.link-cards.description.link.label.ai': 'アトラシアンの AI に関する詳細',
  'custom-sites-extensions.link-cards.error-states.no-data.description-text':
    'このマクロを削除し、新しいマクロを作成してみてください。',
  'custom-sites-extensions.link-cards.error-states.no-data.header-text': '表示するデータがありません',
  'custom-sites-extensions.link-cards.fetch-cover-image.fetch.error.description':
    'ページを更新してもう一度お試しください',
  'custom-sites-extensions.link-cards.fetch-cover-image.fetch.error.title': '画像をアップロードできません',
  'custom-sites-extensions.link-cards.image-failed-to-load': '画像を読み込めませんでした',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2': '配置',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.center': '中央揃え',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.left': '左寄せ',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.right': '右寄せ',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.all-cards.label':
    'すべてのカード',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.each-card.label':
    '個々のカード',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.all-cards.label':
    'すべてのカード',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.each-card.label':
    '個々のカード',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.v2.item.no-segmentation.label':
    'なし',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.info-label':
    '各カードのターゲット グループを追加',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-groups-text-label': '対象グループ',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-groups-text-label.v2':
    'ターゲット オーディエンス グループ',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-text-label':
    '次のカードのターゲット コンテンツ',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-text.v2.label':
    'ターゲットオーディエンス',
  'custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.info-icon-label-v2':
    'カードを表示する Confluence ユーザー グループを選択',
  'custom-sites-extensions.link-cards.warning': '画像を読み込めなかったときの警告アイコン',
  'custom-sites-extensions.link.cards.image.upload.error.flag.description': 'ページを更新してもう一度お試しください。',
  'custom-sites-extensions.link.cards.image.upload.error.flag.title': '画像をアップロードできません',
  'custom-sites-extensions.links-menu.corner.style': '角のスタイル',
  'custom-sites-extensions.links-menu.corner.style-round': '角丸',
  'custom-sites-extensions.links-menu.corner.style-square': 'スクエア',
  'custom-sites-extensions.refined.unsplash.search.placeholder': 'Unsplash を参照',
  'custom-sites-extensions.shared-components.item.collapse.label':
    '{itemLabel, select, card {カードを折りたたむ} frame {フレームを折りたたむ} other {カードを折りたたむ}}',
  'custom-sites-extensions.shared-components.item.expand.label':
    '{itemLabel, select, card {カードを展開} frame {フレームを展開} other {カードを展開}}',
  'custom-sites-extensions.shared-components.item.remove.label':
    '{itemLabel, select, card {カードを削除} frame {フレームを削除} other {カードを削除}}',
  'custom-sites-extensions.shared-components.item.title':
    '{itemLabel, select, card {カード {order}} frame {フレーム {order}} other {カード {order}}}',
  'custom-sites-extensions.shared-components.link-picker.clear-icon-label': 'リンクの選択をクリア',
  'custom-sites-extensions.shared-components.link-picker.popup-placeholder-text': 'リンクを追加',
  'custom-sites-extensions.shared-components.unsplash-search.upload.error.description':
    'ページを更新してもう一度お試しください',
  'custom-sites-extensions.shared-components.unsplash-search.upload.error.title': '画像を読み込めませんでした',
  'custom-sites-extensions.spotlight.button-label.placeholder': '表示',
  'custom-sites-extensions.spotlight.spotlight-config-panel.button-heading': 'ボタン',
  'custom-sites-extensions.spotlight.spotlight-config-panel.button-text-placeholder': '表示',
  'custom-sites-extensions.spotlight.spotlight-config-panel.dark-button-style-label': '代替',
  'custom-sites-extensions.spotlight.spotlight-config-panel.delete-icon-label': '削除',
  'custom-sites-extensions.spotlight.spotlight-config-panel.light-button-style-label': '既定',
  'custom-sites-extensions.spotlight.spotlight-config-panel.mdia-picker-helper-message':
    '最適な結果を得るには、1200 ピクセル以上の高解像度の画像を選択してください。',
  'custom-sites-extensions.spotlight.spotlight-config-panel.media-picker-button-label': 'メディアを選択',
  'custom-sites-extensions.spotlight.spotlight-config-panel.media-picker-content-title': 'メディア',
  'custom-sites-extensions.unsplash-search.default-image-picker.no-image': '画像なし',
  'custom-sites-extensions.unsplash.background-img.default.label': 'アップロード プレビューアーの既定の背景画像',
  'custom-sites-extensions.unsplash.delete.image.text': '画像を削除',
  'custom-sites-extensions.unsplash.error.bad-request-message':
    'Unsplash から応答がありませんでした。再読み込みしてもう一度お試しください。',
  'custom-sites-extensions.unsplash.error.rate-limited-message':
    'Unsplash から応答がありませんでした。しばらく待ってから、もう一度お試しください。',
  'custom-sites-extensions.unsplash.legal':
    'Unsplash の画像を使用すると、Unsplash の{unsplashLicenseLink}と{unsplashTermsOfServiceLink}に同意したものとみなされます。',
  'custom-sites-extensions.unsplash.license': 'ライセンス',
  'custom-sites-extensions.unsplash.search.error.no-network-message': '接続が失われました。もう一度お試しください。',
  'custom-sites-extensions.unsplash.search.load.more.unsplash.photos': 'さらに読み込む',
  'custom-sites-extensions.unsplash.search.no.more.results.to.load.text':
    'これ以上一致するものはありません。別の検索をお試しください。',
  'custom-sites-extensions.unsplash.search.no.results.text': '検索条件に一致するデータがありませんでした',
  'custom-sites-extensions.unsplash.terms.of.service.': 'サービス利用規約',
  'custom-sites-extensions.unsplash.upload.label': 'アップロード',
  'custom-sites-extensions.unsplash.upload.text': 'アップロード',
  label: 'カード数',
};
